import { Component, Input, OnInit } from '@angular/core';

import { LinkTableLink } from './link-table.models';

@Component({
	selector: 'app-link-table',
	templateUrl: './link-table.component.html',
	styleUrls: ['./link-table.component.scss']
})
export class LinkTableComponent implements OnInit {
	@Input() links: LinkTableLink[] = [];
	@Input() title: string;

	constructor() {}

	public ngOnInit() {}
}
